<template>
  <div class="dialog-upload-thesis">
    <Form :label-width="140">
      <FormItem v-for="(item,index) in formItems" :label="item.label" :key="index" :class="item.className">
        <element-upload :url="item.url"
                        :format="item.format"
                        :data="item.data"
                        :comment="item.comment"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import ElementUpload from '@/components/elements/upload'

export default {
  name: 'uploadThesis',
  components: {ElementUpload},
  data () {
    return {
      formItems: [
        {
          label: '回执信息上传：',
          comment: '请上传excel文件',
          format: ['xlsx', 'xls'], // , 'xls', 'dbf'
          url: '/finance/payBillDetail/uploadPayList',
          data: {},
          className: 'summary'
        }
      ]
    }
  },
  methods: {
    handleSuccess () {
      this.$emit('reload');
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.originPaper,summary{
  .kh-form-item-label::before{
   content: '*';
   display: inline-block;
   margin-right: 4px;
   line-height: 1;
   font-family: SimSun;
   font-size: 12px;
   color: #ff7372;
}
}
/deep/.summary{
.kh-form-item-label::before{
   content: '*';
   display: inline-block;
   margin-right: 4px;
   line-height: 1;
   font-family: SimSun;
   font-size: 12px;
   color: #ff7372;
}
}
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/uploadFunds.vue